import React, { useState, Fragment, useEffect } from 'react'
import PropTypes from 'prop-types'
import { FixedSizeList } from 'react-window';
import { AutoSizer } from "react-virtualized";
import { ListItem, ListItemIcon, Checkbox, ListItemText, Button } from '@material-ui/core';
import { PagePlaceholder } from '../page-placeholder/PagePlaceholder';
import { Loading } from '../loading/Loading';

function InfiniteLoadingList({
    // Are there more items to load?
    // (This information comes from the most recent API request.)
    hasNextPage,

    // Are we currently loading a page of items?
    // (This may be an in-flight flag in your Redux store for example.)
    isNextPageLoading,

    // Array of items loaded so far.
    items,

    // Callback function responsible for loading the next page of items.
    loadNextPage,
    ...props
}) {
    const [checked, setChecked] = useState(props.currentSelection || [])

    // If there are more items to be loaded then add an extra row to hold a loading indicator.
    const itemCount = hasNextPage ? items.length + 1 : items.length;

    useEffect(() => {
        handleNew()
    }, [])


    // Only load 1 page of items at a time.
    // Pass an empty callback to InfiniteLoader in case it asks us to load more than once.
    const loadMoreItems =
        isNextPageLoading ?
            () => {}
            :
            (startIndex, stopIndex) => {
                return loadNextPage()
            }
    // Every row is loaded except for our loading indicator row.
    const isItemLoaded = index => !hasNextPage || index < items.length

    function handleNew() {
        if (loadMoreItems != null) {
            loadMoreItems().then()
        }
    }

    function handleToggle(id) {
        const currentIndex = checked.indexOf(id);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(id);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked)
        props.handleSelection(newChecked);
    }

    // Render an item or a loading indicator.
    const Row = ({ index, style }) => {
        if (!isItemLoaded(index)) {
            return (
                <ListItem
                    // key="loading_indicator"
                    role={undefined}
                    dense
                    onClick={() => { }}
                    style={{ ...style, "justifyContent": "center" }}
                    key={index}
                >
                    {isNextPageLoading ?
                        <Loading /> :
                        <Button variant="outlined" color="secondary" margin="dense" onClick={handleNew}>
                            Load More
                        </Button>}
                </ListItem>
            )
        } else {
            const dataItem = items[index]
            if (dataItem != null) {
                return (
                    <ListItem
                        key={dataItem.id}
                        role={undefined}
                        dense
                        button
                        disabled={(props.currentSelection || []).includes(dataItem.id)}
                        onClick={() => handleToggle(dataItem.id)}
                        style={style}
                    >
                        <ListItemIcon>
                            {props.notSelectable ?
                                <div /> :
                                <Checkbox
                                    edge="start"
                                    checked={checked.indexOf(dataItem.id) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{ "aria-labelledby": dataItem.id }}
                                />
                            }
                        </ListItemIcon>
                        <ListItemText id={dataItem.id} primary={dataItem.value} secondary={dataItem.id !== dataItem.value ? dataItem.id : null} />
                    </ListItem>
                )
            } else {
                return null
            }
        }
    }

    return (
        <Fragment>
            {itemCount === 0 ?
                <PagePlaceholder text={props.emptyPlaceholder} /> :
                <AutoSizer>
                    {({ height, width }) => (
                        <FixedSizeList
                            height={height}
                            width={width}
                            itemCount={itemCount}
                            itemSize={50}
                            {...props}
                        >
                            {Row}
                        </FixedSizeList>
                    )}
                </AutoSizer>
            }
        </Fragment>
    )
}

InfiniteLoadingList.propTypes = {
    hasNextPage: PropTypes.bool.isRequired,
    isNextPageLoading: PropTypes.bool.isRequired,
    items: PropTypes.array.isRequired,
    loadNextPage: PropTypes.func.isRequired
}

export default InfiniteLoadingList

